import React, { Component } from "react";
import { FaRegStar, FaStar, FaStarHalfAlt, FaRegSadTear } from "react-icons/fa";
import { MdArrowDropDown } from "react-icons/md";
import { SlUser } from "react-icons/sl";
import axios from "axios";

class TutorCourseReview extends Component {
    state = {
        filter: "All",
        showAll: false,
        showFilterList: false,
        rating: 0,
        comments: [],
        averageRating: 0,
        starCounts: {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
        },
        totalRatings: 0,
        visibleComments: 4,
    }

    componentDidMount() {
        this.fetchCourses();
    }

    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
        if (this.props.shouldRefresh && !prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Call onRefreshDone after fetching
        }
    }

    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id;
            const courseId = parseInt(course_id, 10);

            let headers = {};
            if (accessToken) {
                headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }

            // Fetch both APIs concurrently
            const [userReviewsRes, tutorReviewsRes] = await Promise.all([
                axios.get(`https://api.geoinfoacademy.com/api/courses/${courseId}/reviews/`, { headers }),
                axios.get(`https://api.geoinfoacademy.com/api/tutor/reviews/by-course/?course_id=${courseId}`, { headers }),
            ]);

            const userReviews = userReviewsRes.data;
            const tutorReviews = tutorReviewsRes.data;

            // Format tutor reviews to match the format
            const formattedTutorReviews = tutorReviews.map(review => ({
                id: `tutor-${review.id}`,
                rating: review.rating,
                comment: review.comment,
                created_at: new Date().toISOString(), // Use current date if no date provided
                user: {
                    first_name: review.full_name.split(" ")[0],
                    last_name: review.full_name.split(" ")[1] || "",
                    profile_picture: review.pic_or_video || "", // fallback if not available
                },
            }));

            const allReviews = [...userReviews, ...formattedTutorReviews];

            // Sort by date (optional)
            allReviews.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            this.setState({ comments: allReviews }, () => {
                this.calculateAverageRatingAndStarCounts();
            });
            console.log("user review, tutor review and general review ", userReviews, tutorReviews, allReviews)

        } catch (error) {
            console.error("Error fetching data for review:", error);
        }
    };

    calculateAverageRatingAndStarCounts = () => {
        const { comments } = this.state;
        let totalRating = 0;
        const newStarCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

        comments.forEach(comment => {
            totalRating += comment.rating;
            newStarCounts[comment.rating]++;
        });

        const average = comments.length > 0 ? totalRating / comments.length : 0;

        this.setState({
            averageRating: parseFloat(average.toFixed(1)),
            starCounts: newStarCounts,
            rating: parseFloat(average.toFixed(1)),
            totalRatings: comments.length,
        });
    };

    handlefilterbuttondisplay = () => {
        this.setState(prevState => ({
            showFilterList: !prevState.showFilterList,
        }));
    }

    handlefilter = (filter) => {
        this.setState({
            filter: filter,
            showFilterList: false,
        });
    }

    renderStarRating = (rating) => {
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating - fullStars >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
        const stars = [];

        for (let i = 0; i < fullStars; i++) {
            stars.push(<FaStar key={`full-${i}`} />);
        }

        if (hasHalfStar) {
            stars.push(<FaStarHalfAlt key="half" />);
        }

        for (let i = 0; i < emptyStars; i++) {
            stars.push(<FaRegStar key={`empty-${i}`} />);
        }

        return stars;
    }

    initialfilterbystar = () => {
        const review = this.state.comments;
        const filterValue = this.state.filter;

        if (filterValue === "All") {
            return review;
        } else {
            const filterNumber = parseInt(filterValue, 10);
            return review.filter((item) => item.rating === filterNumber);
        }
    };

    getDisplayedComments = () => {
        const filteredComments = this.initialfilterbystar();
        return this.state.showAll ? filteredComments : filteredComments.slice(0, this.state.visibleComments);
    };

    toggleShowMoreLess = () => {
        this.setState((prevState) => ({
            showAll: !prevState.showAll,
            visibleComments: prevState.showAll ? 4 : prevState.visibleComments,
        }));
    };

    handleReviewDisplay = () => {
        const div = document.querySelector(".dash_add_course_cover.addreview");
        if (div) {
            div.style.display = "flex";
        }
    }

    deleteReview = async (reviewId) => {
    const accessToken = localStorage.getItem("accessToken");

    // Determine review type and extract numeric ID
    let type = "";
    let id = "";

    if (reviewId.startsWith("tutor-")) {
        type = "tutor";
        id = reviewId.replace("tutor-", "");
    } else if (reviewId.startsWith("user-")) {
        type = "user";
        id = reviewId.replace("user-", "");
    } else {
        console.error("Invalid reviewId format:", reviewId);
        return;
    }

    try {
        const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

        // Determine API endpoint based on type
        let deleteUrl = "";
        if (type === "tutor") {
            deleteUrl = `https://api.geoinfoacademy.com/api/tutor/reviews/${id}/`;
        } else {
            deleteUrl = `https://api.geoinfoacademy.com/api/reviews/${id}/`;
        }

        // Perform delete request
        await axios.delete(deleteUrl, { headers });

        // Remove deleted review from state
        this.setState(
            (prevState) => {
                const updatedComments = prevState.comments.filter(
                    (comment) => comment.id !== reviewId
                );
                return { comments: updatedComments };
            },
            () => {
                this.calculateAverageRatingAndStarCounts(); // Recalculate after delete
            }
        );

        console.log(`${type} review ${id} deleted successfully`);
    } catch (error) {
        console.error(`Failed to delete ${type} review ${id}:`, error);
    }
};


    render() {
        const { filter, showFilterList, starCounts, totalRatings, rating } = this.state;
        const displayedComments = this.getDisplayedComments();
        const filteredCommentLength = this.initialfilterbystar().length;
        const shouldShowButton = filteredCommentLength > 4;

        const ReviewList = displayedComments.length ? displayedComments.map((review) => {
            const dateObject = new Date(review.created_at);
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            const month = monthNames[dateObject.getMonth()];
            const day = dateObject.getDate();
            const year = dateObject.getFullYear();
            const formattedDate = `${month} ${day}, ${year}`;

            return (
                <section className="personalcomment" key={review.id}>
                    <div className="container">
                        <div className="image">
                            {review.user.profile_picture === "" ? <SlUser /> :
                                <img src={review.user.profile_picture} alt={review.id + "profile"} />}
                        </div>
                        <div className="content">
                            <h3>{review.user.first_name} {review.user.last_name}<br /><span>Developer</span></h3>
                        </div>
                        <div className="rankstar">{this.renderStarRating(review.rating)}<span>{formattedDate}</span></div>
                        <p>{review.comment}</p>
                        <button className="add" onClick={() => this.deleteReview(review.id)}>Delete</button>
                    </div>
                </section>
            );
        }) : (
            <div className="enroll_error">
                <div className="enroll_cover">
                    <FaRegSadTear />
                    <p>No review yet</p>
                    <button>Make a review</button>
                </div>
            </div>
        );

        return (
            <section className="review_container">
                <h3>Learner Review <button className="add" onClick={this.handleReviewDisplay}>Make a review</button></h3>

                <div className="review_rank">
                    <h2>{rating}<span> out of 5</span></h2>
                    <div className="rank_star">
                        {this.renderStarRating(rating)}
                        <span>{filteredCommentLength} ratings</span>
                    </div>
                </div>

                <div className="review_rank_calculate">
                    <span>Ratings calculate</span><br />
                    {[5, 4, 3, 2, 1].map(star => (
                        <div className="contain" key={star}>
                            <section className="figure">{star} stars</section>
                            <section className="bar">
                                <div className="color" style={{
                                    width: totalRatings > 0
                                        ? `${Math.round((starCounts[star] / totalRatings) * 100)}%`
                                        : '0%'
                                }}></div>
                            </section>
                            <section className="percent">
                                {totalRatings > 0
                                    ? `${Math.round((starCounts[star] / totalRatings) * 100)}%`
                                    : '0%'}
                            </section>
                        </div>
                    ))}
                </div>

                <div className="comment">
                    <nav className="commentfilter">
                        <span>Fliter by:</span>
                        <div className="contain">
                            <button onClick={this.handlefilterbuttondisplay}>{filter} stars <MdArrowDropDown /></button>
                            <div className="filterlist" style={{ display: showFilterList ? "block" : "none" }}>
                                <li onClick={() => this.handlefilter("All")}>All stars</li>
                                <li onClick={() => this.handlefilter("5")}>5 stars</li>
                                <li onClick={() => this.handlefilter("4")}>4 stars</li>
                                <li onClick={() => this.handlefilter("3")}>3 stars</li>
                                <li onClick={() => this.handlefilter("2")}>2 stars</li>
                                <li onClick={() => this.handlefilter("1")}>1 stars</li>
                            </div>
                        </div>
                    </nav>

                    <div className="commentContain">
                        {ReviewList}
                        {shouldShowButton && (
                            <button onClick={this.toggleShowMoreLess} className="show">
                                {this.state.showAll ? "Show Less" : "Show More"}
                            </button>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

export default TutorCourseReview;
